// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/click.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetClickJourneyRequest, GetClickJourneyResponse, GetClickRequest, GetClickResponse, GetClickTraceRequest, GetClickTraceResponse, SearchClicksRequest, SearchClicksResponse } from "./click_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service tracker.v1.ClickService
 */
export const ClickService = {
  typeName: "tracker.v1.ClickService",
  methods: {
    /**
     * @generated from rpc tracker.v1.ClickService.SearchClicks
     */
    searchClicks: {
      name: "SearchClicks",
      I: SearchClicksRequest,
      O: SearchClicksResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.ClickService.GetClick
     */
    getClick: {
      name: "GetClick",
      I: GetClickRequest,
      O: GetClickResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetClickTrace returns the full decision trace + scoring breakdown for one
     * click from tracker.detection_signals.
     *
     * @generated from rpc tracker.v1.ClickService.GetClickTrace
     */
    getClickTrace: {
      name: "GetClickTrace",
      I: GetClickTraceRequest,
      O: GetClickTraceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.ClickService.GetClickJourney
     */
    getClickJourney: {
      name: "GetClickJourney",
      I: GetClickJourneyRequest,
      O: GetClickJourneyResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

